<div class="ml-1 mr-1">
  <div class="columns">
    <div class="column has-background-darkblue has-round-border has-text-white">
      <div class="columns">
        <div class="column is-1 has-text-centered w-10">ID</div>
        <div class="column is-2 has-text-centered">Name</div>
        <div class="column is-3 has-text-centered">Straße</div>
        <div class="column is-1 has-text-centered">PLZ</div>
        <div class="column is-2 has-text-centered">Ort</div>
        <div class="column is-3 has-text-centered w-20">
          <a routerLink="/saved-properties/new"
             class="custom-a-button inverted smaller-a-button does-not-wrap pl-4 pr-4">
            + Objekt hinzufügen
          </a>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="platformProfile && platformProfile.properties">
    <ng-container *ngFor="let savedProperty of platformProfile.properties">
      <div class="columns mt-3">
        <div class="column card has-round-border line-height-is-3">
          <div class="columns">
            <div appTooltip matTooltip="{{savedProperty.ownId}}"
                 class="column is-1 has-text-centered w-10 truncate">{{ savedProperty.ownId }}
            </div>
            <div appTooltip matTooltip="{{savedProperty.name}}"
                 class="column is-2 has-text-centered truncate">{{ savedProperty.name }}
            </div>
            <div appTooltip matTooltip="{{savedProperty.street}}"
                 class="column is-3 has-text-centered truncate">{{ savedProperty.street }}
            </div>
            <div class="column is-1 has-text-centered">{{ savedProperty.zip }}</div>
            <div appTooltip matTooltip="{{savedProperty.town}}"
                 class="column is-2 has-text-centered truncate">{{ savedProperty.town }}
            </div>
            <div class="column is-3 has-text-centered w-20">
              <a routerLink="/saved-properties/{{savedProperty.id}}" [state]="savedProperty" class="custom-a-button">
                Bearbeiten
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="columns mt-3" *ngIf="!platformProfile.properties || platformProfile.properties.length === 0">
    <div class="column has-text-centered">
      Es konnten keine Bestandsobjekte gefunden werden.
    </div>
  </div>
</div>
